import api from "./AxiosInstance";

export class ParticipantsIpmService {

  getAllDocAutorises = async (numcont) => {

    try {
      const response = await api.get(`/Document/getTypeDocPart/${numcont}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  deletepiecejointe = async (file_id,) => {
    try {
      const response = await api.delete(`/Ged/deleteFile/${file_id}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  downloadpiecejointe = async (file_id,) => {
    try {
      const response = await api.get(`/Ged/downloadFile/Part/${file_id}`, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  importpiecejointe = async (numcont, payload) => {
    try {
      const response = await api.post(`/Ged/uploadFiles/${numcont}`, payload, {

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  piecejointes = async (numcont) => {
    try {
      const response = await api.get(`/Ged/list/${numcont}`,);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  documentList = async (numcont, year) => {
    try {
      const response = await api.get(`/Document/ByParticipant/list/${numcont}/${year}/IPM`,);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  printList = async (payload) => {
    try {
      const response = await api.post(`/Participant/PrintList`, payload, {});
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  searchParticipantIpm = async (payload) => {
    try {
      const response = await api.post(`/Participant/Search/List`, payload);

      return response.data;
    } catch (error) {
      console.error("Erreur lors de l'ajout de prestation :", error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getParticipantsSoc = async (codesoc) => {
    try {
      const response = await api.get(`/Participant/Societe/${codesoc}`, {});
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getAllParticipantsIpm = async (codesoc) => {
    try {
      const response = await api.get(`/Participant/Societe/${codesoc}`, {});
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getMedicamentList = async () => {
    try {
      const response = await api.get(`/LignePrestations/Actes/list/06`, {});
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getOptiqueList = async () => {
    try {
      const response = await api.get(`/LignePrestations/Actes/list/04`, {});
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getVerifOptique = async (matribenef) => {
    try {
      const response = await api.get(
        `/Participant/VerifOptique?matribenef=${matribenef}`,
        {}
      );
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getOneParticipant = async (numcont) => {
    try {
      const response = await api.get(`/Participant/${numcont}`, {});
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getBenefParticipant = async (numcont) => {
    try {
      const response = await api.get(`/Benef/list/Doc/${numcont}`, {});
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getOneListtParticipant = async (codeadht) => {
    try {
      const response = await api.get(`/Participant/List/${codeadht}`, {});
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  getOneEtParticipant = async (codeadht) => {
    try {
      const response = await api.get(
        `/Participant/Societe/Edit/${codeadht}`,
        {}
      );
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  getOneListParticipant = async (numcont) => {
    try {
      const response = await api.get(`/Participant/Conso/${numcont}`, {});
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };



  updateListParticipant = async (updatedParticipant) => {
    try {
      const response = await api.put(
        `/Participant/Update/Actif`,
        updatedParticipant
      );

      return response.data;
    } catch (error) {
      console.error("Erreur lors de la mise à jour de prestation :", error);
      throw error;
    }
  };

  ///Participant/Toggle

  putcodesoc = async (payload) => {
    try {
      const response = await api.put(
        `/Participant/Toggle`,
        payload
      );

      return response.data;
    } catch (error) {
      console.error("Erreur lors de la mise à jour :", error);
      throw error;
    }
  };

  addParticipantIpm = async (newParticipant) => {
    try {
      const response = await api.post(`/Participant/add`, newParticipant);

      return response.data;
    } catch (error) {
      console.error("Erreur lors de l'ajout de prestation :", error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };
  deleteParticipantIpm = async (numcont) => {
    try {
      const response = await api.delete(`Participant/delete/${numcont}`);

      return response.data;
    } catch (error) {
      console.error("Erreur lors de l'ajout de prestation :", error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };



  fetchImage = async (matripart) => {
    try {
      const res = await api.get(`Participant/getPhoto/${matripart}`, { responseType: 'arraybuffer' });
      console.log("API Response:", res);

      if (res.data) {
        const imageBlob = new Blob([res.data], { type: 'image/jpeg' });
        const imageObjectURL = URL.createObjectURL(imageBlob);
        return imageObjectURL;
      } else {
        console.error("Aucune donnée trouvée pour cette matripart");
        return null;
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  fetchImageLogo = async () => {
    try {
      const res = await api.get(`InfosGen/getEntete/logo`, { responseType: 'arraybuffer' });
      console.log("API Response:", res);

      if (res.data) {
        const imageBlob = new Blob([res.data], { type: 'image/jpeg' });
        const imageObjectURL = URL.createObjectURL(imageBlob);
        return imageObjectURL;
      } else {
        console.error("Aucune donnée trouvée ");
        return null;
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };
  fetchImageSignature = async () => {
    try {
      const res = await api.get(`InfosGen/getEntete/signature`, { responseType: 'arraybuffer' });
      console.log("API Response:", res);

      if (res.data) {
        const imageBlob = new Blob([res.data], { type: 'image/jpeg' });
        const imageObjectURL = URL.createObjectURL(imageBlob);
        return imageObjectURL;
      } else {
        console.error("Aucune donnée trouvée ");
        return null;
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  fetchImgDetail = async (numcont) => {
    try {
      const res = await api.get(`Participant/getPhoto/${numcont}`, { responseType: 'arraybuffer' });
      console.log("API Response:", res);

      if (res.data) {
        const imageBlob = new Blob([res.data], { type: 'image/jpeg' });
        const imageObjectURL = URL.createObjectURL(imageBlob);
        return imageObjectURL;
      } else {
        console.error("Aucune donnée trouvée pour cette matripart");
        return null;
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  fetchImageBenef = async (matribenef) => {
    try {
      const res = await api.get(`Participant/getPhoto/${matribenef}`, { responseType: 'arraybuffer' });
      console.log("API Response:", res);

      if (res.data) {
        const imageBlob = new Blob([res.data], { type: 'image/jpeg' });
        const imageObjectURL = URL.createObjectURL(imageBlob);
        return imageObjectURL;
      } else {
        console.error("Aucune donnée trouvée pour cette matripart");
        return null;
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  /*  addPhoto = async (matripart, formData) =>{
     try {
       const res = api.post(`/Participant/addPhoto/${matripart}`, formData, {
       headers: {
         'Content-Type': 'multipart/form-data',
       },
     });
     return response.res;
   }
   } ; */

}
